import React, { Component } from 'react';
import Intro from '../../organisms/Intro';

class Home extends Component {

  render() {

    return (
      <div className="Home">
        <Intro />
      </div>
    );

  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/component/pages/Home/index.js